import React, { useState, useEffect } from "react";
import ReusableTable from "../../components/Employee/Table";
import {
  confirmDeletePopup,
  formatDateOnly,
  openAllowanceTypeModal,
  successPopup,
} from "../../util/common";
import TextInput from "../../components/Reusable/TextInput";
import SelectInput from "../../components/Reusable/SelectInput";
import DateInput from "../../components/Reusable/DateInput";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaTrash } from "react-icons/fa";
import Swal from "sweetalert2";
import {
  useCreateNewAllowanceType,
  useGetAllAllowanceTypesPaginated,
  useGetAllEmployeeSalaryRecordsPaginated,
  useGetAllowanceTypeById,
  useUpdateAllowanceType,
} from "../../hooks/usePayroll";
import "./sweetalert.css";
import { toast } from "react-toastify";

function SalaryRecordLayout() {
  const [pageCount, setPageCount] = useState(1);
  const navigate = useNavigate();

  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 20,
  });

  const [filter, setFilter] = useState({
    filterField1: "Current",
    filterValue1: true,
  });

  const handleOnPageChange = (pageIndex, pageSize) => {
    setPagination({
      page: pageIndex + 1,
      pageSize,
    });
  };

  const [salaryRecords, setEmployeeSalaryRecords] = useState([]);
  const employeeSalaryRecords = useGetAllEmployeeSalaryRecordsPaginated();
  const fetchAllowanceTypeRecords = async () => {
    employeeSalaryRecords.mutate(
      {
        page: pagination.page,
        pageSize: pagination.pageSize,
        filterField1: filter.filterField1,
        filterValue1: filter.filterValue1,
      },
      {
        onSuccess: async (result) => {
          if (!result.success) return;
          const records = result.data.data.map((r) => ({
            ...r,
            FromDate: formatDateOnly(r.FromDate),
            EffectiveDate: formatDateOnly(r.EffectiveDate),
            Current: r.Current ? "Yes" : "No",
            TaxExempt: r.TaxExempt ? "Yes" : "No",
            IsFixedSalary: r.IsFixedSalary ? "Yes" : "No",
            EmployeeFullName: r.Employee.FullName,
            EmployeeCode: r.Employee.EmployeeCode,
          }));
          setEmployeeSalaryRecords(records);
          setPageCount(result.data.pagination.totalPages);
        },
      }
    );
  };

  useEffect(() => {
    fetchAllowanceTypeRecords();
  }, [pagination, filter]);

  const handleEdit = (salaryRecord) => {
    if (!salaryRecord) return;
    navigate(`/EditSalaryRecord/${salaryRecord.id}`);
  };

  const handleDelete = async (salaryRecord) => {
    const isConfirmed = await confirmDeletePopup({
      text: `Are you sure you want to delete ${salaryRecord.Code}?`,
    });

    if (isConfirmed) {
    }
  };

  const tableColumns = [
    { accessorKey: "EmployeeCode", header: "Employee Code" },
    { accessorKey: "EmployeeFullName", header: "Employee" },
    { accessorKey: "BasicSalary", header: "Basic Salary" },
    { accessorKey: "EffectiveDate", header: "Effective Date" },
    { accessorKey: "FromDate", header: "From Date" },
    { accessorKey: "IsFixedSalary", header: "Is Fixed" },
    { accessorKey: "PayFrequency", header: "Pay Frequency" },
    { accessorKey: "TaxExempt", header: "Tax Exempt" },
    { accessorKey: "Current", header: "Current" },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => {
        const salaryRecord = row.original;

        return (
          <div style={{ display: "flex", gap: "10px" }}>
            <FaEdit
              title="Edit"
              style={{ cursor: "pointer" }}
              onClick={() => handleEdit(salaryRecord)}
            />

            {/* <FaTrash
              title="Delete"
              style={{ cursor: "pointer", color: "red" }}
              onClick={() => handleDelete(salaryRecord)}
            /> */}
          </div>
        );
      },
    },
  ];

  const handleAddAllowanceType = async () => {};

  return (
    <div className="overtime-form-container">
      <h2>Employee Salary Records</h2>
      <form className="overtime-form">
        <div className="form-group full-width file-upload-section">
          <div className="attendance-filters">
            <div className="action-btns">
              <button
                className="overtime-btn"
                onClick={() => navigate("/AddSalaryRecord")}
                type="button"
              >
                + Add Employee Salary Record
              </button>
            </div>
            <div className="attendance-records">
              <ReusableTable
                data={salaryRecords}
                columns={tableColumns}
                mode="server"
                initialPageSize={pagination.pageSize}
                onPageChange={handleOnPageChange}
                pageCount={pageCount}
                page={pagination.page - 1}
                pageSize={pagination.pageSize}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default SalaryRecordLayout;
